"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Order status
 * @export
 * @enum {string}
 */
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Previewed"] = "PREVIEWED";
    OrderStatus["Placed"] = "PLACED";
    OrderStatus["Accepted"] = "ACCEPTED";
    OrderStatus["Cancelled"] = "CANCELLED";
    OrderStatus["Filled"] = "FILLED";
    OrderStatus["PartiallyFilled"] = "PARTIALLY_FILLED";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["WaitingCancellation"] = "WAITING_CANCELLATION";
    OrderStatus["WaitingReplace"] = "WAITING_REPLACE";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
function OrderStatusFromJSON(json) {
    return OrderStatusFromJSONTyped(json, false);
}
exports.OrderStatusFromJSON = OrderStatusFromJSON;
function OrderStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.OrderStatusFromJSONTyped = OrderStatusFromJSONTyped;
function OrderStatusToJSON(value) {
    return value;
}
exports.OrderStatusToJSON = OrderStatusToJSON;
